import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiStar, FiCheck } from 'react-icons/fi';

const reviews = [
  {
    name: "Cindy Mcalpin",
    date: "Mar 11, 2026",
    text: "Handy when needed to help. Really helps me focus when I am searching for comfort.",
    tags: ["Recommends"]
  },
  {
    name: "Amy",
    date: "Mar 11, 2026",
    text: "Perfect bible bookmark to turn to a page you may need! The designs are beautiful.",
    tags: ["Recommends"]
  },
  {
    name: "Jessie Garcia Schnell",
    date: "Mar 10, 2026",
    text: "Perfect bible bookmarks! I love having these verses handy! Thank you so much!",
    tags: ["Recommends"]
  },
  {
    name: "Lindsay Zalonis",
    date: "Mar 10, 2026",
    text: "Such a cute gift idea! Sturdy material once printed and cute designs!",
    tags: ["Recommends"]
  },
  {
    name: "Dymalia Rivera-Cintron",
    date: "Mar 9, 2026",
    text: "My boys and I love them. A great way to introduce them to specific verses.",
    tags: ["Recommends"]
  }
];

const Reviews = () => {
  return (
    <section className="py-20 bg-stone-900 text-stone-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-white">Loved by Our Community</h2>
            <p className="text-stone-400 text-lg">See why hundreds of book lovers and believers are using these bookmarks daily.</p>
          </div>
          <div className="bg-stone-800 px-6 py-4 rounded-2xl border border-stone-700 flex items-center gap-4">
            <div className="text-3xl font-bold text-amber-400">5.0</div>
            <div>
              <div className="flex text-amber-400 text-sm">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current" />)}
              </div>
              <div className="text-xs text-stone-400 uppercase tracking-wider font-bold">Average Rating</div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-stone-800 p-6 rounded-2xl border border-stone-700 flex flex-col h-full">
              <div className="flex items-center gap-2 mb-4">
                {review.tags.map((tag, i) => (
                  <span key={i} className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-amber-500/10 text-amber-400 px-2 py-1 rounded border border-amber-500/20">
                    <SafeIcon icon={FiCheck} /> {tag}
                  </span>
                ))}
              </div>
              <p className="text-stone-200 mb-8 italic text-lg leading-relaxed">"{review.text}"</p>
              <div className="mt-auto pt-6 border-t border-stone-700/50 flex items-center justify-between">
                <span className="font-bold text-white">{review.name}</span>
                <span className="text-xs text-stone-500">{review.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;